import baseURLv1 from '@/services/APIConfig.js';
import { set } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    enums: {
      countries: [],
      family_relations: [],
      form_types: [],
      genders: [],
      hire_origins: [],
      languages: [],
      notification_types: [],
      permit_document_statuses: [],
      permit_types: [],
      roles: [],
      survey_types: [],
      time_zones: [],
      user_statuses: [],
      marital_statuses: [],
    },
    permit_document_statuses: [{
      id: 10,
      value: 'Missing',
      color: 'red',
      key: 'foreigners.permits.documents.statuses.missing',
    },
    {
      id: 20,
      value: 'Waiting for review',
      color: 'yellow',
      key: 'foreigners.permits.documents.statuses.waiting',
    },
    {
      id: 30,
      value: 'Accepted',
      color: 'green',
      key: 'foreigners.permits.documents.statuses.accepted',
    }],
    interface_languages: [],
    support_specification: [],
    support_timeline: [],
    admin_audit_events: [],
    foreigner_audit_events: [],
    audit_severities: [],
    agency_user_roles: [],
    client_user_roles: [],
    internal_user_roles: [],
  },
  mutations: {
    set,
  },
  actions: {
    async loadEnums({ commit }) {
      const enums = await this.$axios.$get(`${baseURLv1}/core/enum/`);

      const enumNamesToCapitalize = [
        'family_relations',
        'languages',
        'form_types',
        'genders',
        'user_statuses',
        'marital_statuses',
        'notification_types',
        'notification_flags',
        'hire_origins',
        'permit_types',
        'permit_document_statuses',
      ];

      const uppercaseEnums = Object.entries(enums).reduce((acc, [key, values]) => {
        if (enumNamesToCapitalize.includes(key)) {
          acc[key] = values.map(({ id, name_text, name }) => ({
            id,
            name_text: this.$capitalize(name_text),
            name: this.$capitalize(name),
          }));
        } else {
          acc[key] = values;
        }
        return acc;
      }, {});

      commit('set', ['enums', uppercaseEnums]);
    },
    async loadSupportSpecifications({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/survey/support_specification/`);

      commit('set', ['support_specification', items]);
    },
    async loadSupportTimeline({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/survey/support_timeline/`);

      commit('set', ['support_timeline', items]);
    },
    async loadInterfaceLanguages({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/core/interface_language/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['interface_languages', upperCaseItems]);
    },
    async loadAdminAuditEvents({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/audit/event/administration/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['admin_audit_events', upperCaseItems]);
    },
    async loadForeignerAuditEvents({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/audit/event/foreigner/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['foreigner_audit_events', upperCaseItems]);
    },
    async loadAuditSeverities({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/audit/severity/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['audit_severities', upperCaseItems]);
    },
    async loadAgencyUserRoles({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/user/agency/role/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['agency_user_roles', upperCaseItems]);
    },
    async loadClientUserRoles({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/user/client/role/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['client_user_roles', upperCaseItems]);
    },
    async loadInternalUserRoles({ commit }) {
      const items = await this.$axios.$get(`${baseURLv1}/user/internal/role/`);

      const upperCaseItems = items.map((item) => ({
        ...item,
        name: this.$capitalize(item.name),
      }));

      commit('set', ['internal_user_roles', upperCaseItems]);
    },
  },
  getters: {
    get: (state) => (key, id) => {
      return state.enums[key].find((item) => item.id === id);
    },
    countryById: (state) => (id) => {
      return state.enums.countries.find((el) => el.id === id);
    },
    getHireOrigin: (state) => (id) => {
      return state.enums.hire_origins.find((el) => el.id === id);
    },
    dialCodes: (state) => {
      return state.enums.countries.map((country) => {
        return {
          id: country.id,
          code: country.dial_code,
          codePlus: '+ ' + country.dial_code + ' (' + country.code_alpha3 + ')',
        };
      });
    },
    integerItems: () => {
      return [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
      ];
    },
    isAuditSeveritiesEmpty: (state) => {
      return state.audit_severities.length === 0;
    },
    getForeignerPermitDocumentStatusById: (state) => (id) => {
      // TODO: add translations to the backend response (enums.permit_document_statuses) and add mappinng functions from id to color
      return state.permit_document_statuses.find((el) => el.id === id);
    },
  },
};
